import dayjs from 'dayjs'
import core from '@/rahmen/core'

/**
 * @file 文字列補完処理モジュール
 * @namespace rahmen
 */

/**
 * @module complement
 */
export default {

  /**
   * 日付補完
   * @param {String} dt 補完対象
   * @returns String
   */
  parseDate: function (dt) {
    const org = dt || ''
    return org.indexOf('/') === -1 ? this._dataParseNumOnly(org) : this._dataParseWithSlash(org)
  },

  /**
   * 年月補完
   * @param {String} ym 補完対象
   * @returns String
   */
  parseYearMonth: function (ym) {
    const org = ym || ''
    return org.indexOf('/') === -1 ? this._parseYearMonthNumOnly(org) : this._parseYearMonthWithSlash(org)
  },

  /**
   * 時刻補完
   * @param {String} tm 補完対象
   * @param {Boolean} isStraddle 日跨ぎ可否
   * @returns String
   */
  parseTime: function (tm, isStraddle) {
    const org = tm || ''
    return org.indexOf(':') === -1 ? this._parseTimeNumOnly(org, isStraddle) : this._parseTimeWithColon(org, isStraddle)
  },

  /**
   * 郵便番号フォーマット
   * @param {String} pc フォーマット対象
   * @returns String
   */
  parsePostCode: function (pc) {
    const org = pc || ''
    return this._parsePostCode(org)
  },

  /**
   * 郵便番号フォーマット除去
   * @param {String} pc フォーマット済み郵便番号
   * @returns String
   */
  unformatPostCode: function (pc) {
    const org = pc || ''
    return org.split('-').join('')
  },

  /**
   * 郵便番号フォーマット処理
   * @param {String} pc フォーマット対象文字列
   * @returns String
   * @private
   */
  _parsePostCode: function (pc) {
    if (pc === '' || pc === undefined || pc === null) { return pc }
    const val = this.unformatPostCode(pc)
    if (!core.isNumeric(val)) { return pc }
    if (val.length !== 7) { return pc }
    return `${val.substr(0, 3)}-${val.substr(3, 4)}`
  },

  /**
   * /付き日付補完処理
   * @param {String} dt 日付文字列
   * @returns String
   * @private
   */
  _dataParseWithSlash: function (dt) {
    if (dt === '' || dt === undefined || dt === null) { return dt }

    const delimiter = '/'
    const slashCount = dt.match(new RegExp(delimiter, 'g') || []).length
    if (slashCount > 2) { return dt }

    let y = 0
    let m = 0
    let d = 0

    if (slashCount === 1) {
      const parts = dt.split('/')
      const ms = parts[0]
      const ds = parts[1]

      if (!core.isNumeric(ms) || !core.isNumeric(ds)) { return dt }
      y = dayjs().year()
      m = parseInt(ms, 10)
      d = parseInt(ds, 10)
    } else {
      const parts = dt.split('/')
      const ys = parts[0]
      const ms = parts[1]
      const ds = parts[2]

      if (!core.isNumeric(ys) || !core.isNumeric(ms) || !core.isNumeric(ds)) { return dt }
      y = parseInt(ys, 10)
      m = parseInt(ms, 10)
      d = parseInt(ds, 10)

      if (y < 100) { y += 2000 }
    }

    var isValid = dayjs(`${y}-${m}-${d}`, 'YYYY-M-D', true).isValid()
    if (isValid) { isValid = (`${y}-${m}-${d}` === dayjs(`${y}-${m}-${d}`, 'YYYY-M-D', true).format('YYYY-M-D')) }
    return isValid ? dayjs(`${y}-${m}-${d}`, 'YYYY-M-D', true).format('YYYY/MM/DD') : dt
  },

  /**
   * /無し日付補完処理
   * @param {String} dt 補完対象
   * @returns String
   * @private
   */
  _dataParseNumOnly: function (dt) {
    if (dt === '' || dt === undefined || dt === null) { return dt }
    if (!core.isNumeric(dt)) { return dt }
    const org = dt.trim()
    const today = dayjs()
    let dtstr = ''
    const len = org.length

    if (len <= 2) {
      dtstr = today.format(`YYYY-MM-${org.padStart(2, '0')}`)
    } else if (len <= 4) {
      const md = org.padStart(4, '0')
      const mm = md.substr(0, 2)
      const dd = md.substr(2)

      dtstr = today.format(`YYYY-${mm}-${dd}`)
    } else if (len <= 6) {
      const ymd = org.padStart(6, '0')
      const y = '20' + ymd.substr(0, 2)
      const mm = ymd.substr(2, 2)
      const dd = ymd.substr(4, 2)

      dtstr = `${y}-${mm}-${dd}`
    } else if (len === 8) {
      const ymd = org.padStart(8, '0')
      const y = ymd.substr(0, 4)
      const mm = ymd.substr(4, 2)
      const dd = ymd.substr(6, 2)

      dtstr = `${y}-${mm}-${dd}`
    } else {
      return dt
    }

    console.log(dt, len, dtstr)

    var isValid = dayjs(dtstr, 'YYYY-MM-DD').isValid()
    if (isValid) { isValid = (dtstr === dayjs(dtstr, 'YYYY-MM-DD', true).format('YYYY-MM-DD')) }
    return isValid ? dayjs(dtstr, 'YYYY-MM-DD').format('YYYY/MM/DD') : dt
  },

  /**
   * /付き年月補完処理
   * @param {String} dt 補完対象
   * @returns String
   * @private
   */
  _parseYearMonthWithSlash: function (dt) {
    if (dt === '' || dt === undefined || dt === null) { return dt }

    const delimiter = '/'
    const slashCount = dt.match(new RegExp(delimiter, 'g') || []).length
    if (slashCount > 1) { return dt }

    let y = 0
    let m = 0
    const d = 1

    const parts = dt.split('/')
    const ys = parts[0]
    const ms = parts[1]

    if (!core.isNumeric(ms) || !core.isNumeric(ys)) { return dt }
    y = parseInt(ys, 10)
    m = parseInt(ms, 10)

    if (y < 1000) {
      y += 2000
    }

    var isValid = dayjs(`${y}-${m}-${d}`, 'YYYY-M-D', true).isValid()
    if (isValid) { isValid = (`${y}-${m}-${d}` === dayjs(`${y}-${m}-${d}`, 'YYYY-M-D', true).format('YYYY-M-D')) }
    return isValid ? dayjs(`${y}-${m}-${d}`, 'YYYY-M-D', true).format('YYYY/MM') : dt
  },

  /**
   * /なし年月補完処理
   * @param {String} dt 補完対象
   * @returns String
   * @private
   */
  _parseYearMonthNumOnly: function (dt) {
    if (dt === '' || dt === undefined || dt === null) { return dt }
    if (!core.isNumeric(dt)) { return dt }
    const org = dt.trim()
    const today = dayjs()
    let dtstr = ''
    const len = org.length

    if (len <= 2) {
      dtstr = today.format(`YYYY-${org.padStart(2, '0')}-01`)
    } else if (len <= 4) {
      const ym = org.padStart(4, '0')
      const yy = '20' + ym.substr(0, 2)
      const mm = ym.substr(2, 2)

      dtstr = today.format(`${yy}-${mm}-01`)
    } else if (len === 6) {
      const ymd = org.padStart(6, '0')
      const y = ymd.substr(0, 4)
      const mm = ymd.substr(4, 2)

      dtstr = `${y}-${mm}-01`
    } else {
      return dt
    }

    console.log(dt, len, dtstr)

    var isValid = dayjs(dtstr, 'YYYY-MM-DD').isValid()
    if (isValid) { isValid = (dtstr === dayjs(dtstr, 'YYYY-MM-DD', true).format('YYYY-MM-DD')) }
    return isValid ? dayjs(dtstr, 'YYYY-MM-DD').format('YYYY/MM') : dt
  },

  /**
   * :付き時刻補完処理
   * @param {String} dt 補完対象
   * @returns String
   * @private
   */
  _parseTimeWithColon: function (dt, isStraddle) {
    if (dt === '' || dt === undefined || dt === null) { return dt }

    const upperHour = isStraddle ? 99 : 23
    const delimiter = ':'
    const slashCount = dt.match(new RegExp(delimiter, 'g') || []).length
    if (slashCount > 1) { return dt }

    let h = 0
    let m = 0

    const parts = dt.split(':')
    const hs = parts[0]
    const ms = parts[1]

    if (!core.isNumeric(ms) || !core.isNumeric(hs)) { return dt }
    h = parseInt(hs, 10)
    m = parseInt(ms, 10)

    if (!(h >= 0 && upperHour >= h && m >= 0 && m <= 59)) {
      return dt
    }

    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
  },

  /**
   * /なし時刻補完処理
   * @param {String} dt 補完対象
   * @returns String
   * @private
   */
  _parseTimeNumOnly: function (dt, isStraddle) {
    if (dt === '' || dt === undefined || dt === null) { return dt }
    if (!core.isNumeric(dt)) { return dt }
    const upperHour = isStraddle ? 99 : 23
    const org = dt.trim()
    const len = org.length

    if (len <= 2 || len > 4) {
      return dt
    }

    const tmstr = String(dt).padStart(4, '0')
    const h = tmstr.substr(0, 2)
    const m = tmstr.substr(2)

    console.log(dt, tmstr, h, m)

    if (!(h >= 0 && upperHour >= h && m >= 0 && m <= 59)) {
      return dt
    }

    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
  }
}
